// 事件类型常量
export const EVENT_TYPES = {
  // 通用
  ARPEGGIO: 4,
  KEY: 6,
  // C1/C2 私有
  DRUM: 3,
  PICK: 7,
  // U1 私有
  U1_STYLE: 10, // 风格包
  U1_PICK: 11, // 情绪拨片
  U1_DRUM: 12, // 情绪鼓机
};
